import { render, staticRenderFns } from "./BasePrice.vue?vue&type=template&id=20826c2a&"
import script from "./BasePrice.vue?vue&type=script&lang=js&"
export * from "./BasePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20826c2a')) {
      api.createRecord('20826c2a', component.options)
    } else {
      api.reload('20826c2a', component.options)
    }
    module.hot.accept("./BasePrice.vue?vue&type=template&id=20826c2a&", function () {
      api.rerender('20826c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BasePrice.vue"
export default component.exports